import Api from '../services/api.js'
import { GET_USERS_REQUEST, GET_USERS_SUCCESS, GET_USERS_FAILURE, LOGIN_SUCCESS } from '../constants/user'

export function getUsersRequest(){
  return {
    type: GET_USERS_REQUEST
  }
}

export function getUsersSuccess(body){
  return {
    type: GET_USERS_SUCCESS,
    body: body
  }
}

export function getUsersFailure(exception){
  return {
    type: GET_USERS_FAILURE,
    exception: exception
  }
}

export function logInSuccess(body){
  return {
    type: LOGIN_SUCCESS,
    body: body
  }
}

export function getUsers() {
  return dispatch => {
    dispatch(getUsersRequest())
    const api = new Api();
    return api.get("/api/v1/users")
    .then(response => {
      Promise.all([
        dispatch(getUsersSuccess(response.data))
      ]).then(() => {
        //do no more
      });
    })
    .catch(err => dispatch(getUsersFailure(err)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/user.js